import { render, staticRenderFns } from "./UserPredictileRoleModal.vue?vue&type=template&id=63d68ddf"
import script from "./UserPredictileRoleModal.vue?vue&type=script&lang=js"
export * from "./UserPredictileRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports